// test2732
(2732 && 0);
